export default class {
    _id;
    _name;
    _clientType;
    _clientCode;
    _organizationId;
    _branchId;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get clientType() {
        return this._clientType;
    }

    set clientType(value) {
        this._clientType = value;
    }

    get clientCode() {
        return this._clientCode;
    }

    set clientCode(value) {
        this._clientCode = value;
    }

    get organizationId() {
        return this._organizationId;
    }

    set organizationId(value) {
        this._organizationId = value;
    }

    get branchId() {
        return this._branchId;
    }

    set branchId(value) {
        this._branchId = value;
    }
    constructor(id, name) {
        this._id = id;
        this._name = name;
    }
}
